import { render, staticRenderFns } from "./TicketCorpCard.vue?vue&type=template&id=6b7fdd68&"
import script from "./TicketCorpCard.vue?vue&type=script&lang=js&"
export * from "./TicketCorpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports